import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Box from '@mui/material/Box';

const steps = [
  'Synced with Xero',
  "Your organization's details",
  'Connect with Crypto Wallets',
  'Finish',
];

const OnboardingStepper = ({ activeStep }) => {
  // MUI Stepper is 0-indexed, but our steps might be conceptually 1-indexed.
  // Adjust if necessary, assuming activeStep prop is 1-based for now.
  const zeroBasedActiveStep = activeStep - 1; 

  return (
    <Box sx={{ width: '100%', my: 4 }}> {/* Add some vertical margin */}
      <Stepper activeStep={zeroBasedActiveStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

OnboardingStepper.propTypes = {
  activeStep: PropTypes.number.isRequired, // Expecting 1-based index (1, 2, 3, 4)
};

export default OnboardingStepper;
